import { $http } from '@/utils/https';
import type { IFilter } from '@/store/modules/filters';

interface State {
  reviewProducts: Array<{ id: number; title: string }>;
}

const state: State = {
  reviewProducts: []
};

const getters = {
  reviewProducts: (state: State) => state.reviewProducts
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  GET_CLIENTS_REVIEWS: async ({ commit }: any, params: any) => {
    let url = `v1/all_product_feedbacks`;
    try {
      const response = await $http.get(url, { params: { ...params, is_professional: 0 } });
      return response.data;
    } catch (e) {
      throw e;
    }
  },
  // eslint-disable-next-line no-unused-vars
  GET_PROFESSIONALS_REVIEWS: async ({ commit }: any, params: any) => {
    let url = `v1/all_product_feedbacks`;

    try {
      const response = await $http.get(url, { params: { ...params, is_professional: 1 } });
      return response.data;
    } catch (e) {
      throw e;
    }
  },

  GET_REVIEWS_PRODUCTS: async ({ commit }: any) => {
    let url = `v1/catalog/select/products`;
    try {
      const response = await $http.get(url);
      console.log('response', { response: response });
      commit('SET_REVIEW_PRODUCTS', response.data);
      return response.data;
    } catch (e) {
      throw e;
    }
  }
};

const mutations = {
  SET_REVIEW_PRODUCTS(state: any, data: Array<IFilter>) {
    state.reviewProducts = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
